import { render, staticRenderFns } from "./YoutubeDialog.vue?vue&type=template&id=0610fbe8&scoped=true"
import script from "./YoutubeDialog.vue?vue&type=script&lang=js"
export * from "./YoutubeDialog.vue?vue&type=script&lang=js"
import style0 from "./YoutubeDialog.vue?vue&type=style&index=0&id=0610fbe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0610fbe8",
  null
  
)

export default component.exports